// Flow types automatically removed

import { FormattedMessage } from 'dibs-react-intl';
import { Spinner } from 'dibs-elements/exports/Spinner';
import { Button } from 'dibs-elements/exports/Button';
import styles from '../styles/submit.scss';

const Submit = ({ label, isSending, disabled, onClick }) => {
    const savingLabel = (
        <FormattedMessage id="shareModal.submit.sending" defaultMessage="Sending..." />
    );
    return (
        <Button
            className={styles.button}
            disabled={disabled || isSending}
            onClick={onClick}
            dataTn="share-modal-submit"
        >
            {isSending && <Spinner dark containerClass={styles.inlineSpinner} />}
            {isSending ? savingLabel : label}
        </Button>
    );
};

Submit.defaultProps = {
    label: '',
    disabled: false,
    isSending: false,
    onClick: () => {},
};
export default Submit;
